<template>
    <div class="fourth_step-container">
        <div class="top-container">
            <div class="aside">
                <parameters-aside/>
                <admin-selection/>
            </div>
            <main>
                <calculating-progress  v-if="calculatingInProces"/>
                <fan-graph-summary :footer-circle-radius="4" v-if="!calculatingInProces"/>
                <work-point-collapse v-if="!calculatingInProces"/>
                <graph-parts-collapse v-if="!calculatingInProces"/>
            </main>
            <div class="parametres-container" v-if="calculatingInProces"/>
            <collapse-elements-aside v-if="!calculatingInProces"/>
        </div>

        <div class="bottom-container" v-if="!calculatingInProces">
            <fans-table :load="true" />
        </div>
    </div>
</template>

<script>
    import ParametersAside from "@/components/configuration_steps/fourthStep/ParametersAside";
    import AdminSelection from "@/components/configuration_steps/fourthStep/AdminSelection";
    import CollapseElementsAside from "@/components/configuration_steps/fourthStep/CollapseElementsAside";
    import WorkPointCollapse from "@/components/configuration_steps/fourthStep/WorkPointCollapse";
    import GraphPartsCollapse from "@/components/configuration_steps/fourthStep/GraphPartsCollapse";
    import FansTable from "@/components/configuration_steps/fourthStep/FansTable";
    import FanGraphSummary from "./FanGraphSummary";
    import CalculatingProgress from './CalculatingProgress'

    export default {
        name: "FourthStep",
        components: {
            FanGraphSummary,
            ParametersAside,
            AdminSelection,
            CollapseElementsAside,
            WorkPointCollapse,
            GraphPartsCollapse,
            FansTable,
            CalculatingProgress
        },
        data() {
            return {
                calculatingInProces: false,
            }
        },
        methods: {
            //NVS-101
            selectFanRowAsActiveInFansTable(fan) {
                let fanObj = {
                type: 'selectFanRowAsActiveInFansTable',
                fan_id: fan.id
                };

                this.$store.commit(fanObj);
            },
            async LoadFansOfPath() {
                if (!this.$store.state.lastPathParameters ||
                    this.$store.state.lastPathParameters.selectedFirstStepElement != this.$store.state.selectedFirstStepElement.id ||
                    this.$store.state.lastPathParameters.selectedSecondStepElement != this.$store.state.selectedSecondStepElement.id ||
                    this.$store.state.lastPathParameters.selectedThirdStepElement != this.$store.state.selectedThirdStepElement.id
                ) {
                    this.$store.state.lastPathParameters = {
                        selectedFirstStepElement: this.$store.state.selectedFirstStepElement.id,
                        selectedSecondStepElement: this.$store.state.selectedSecondStepElement.id,
                        selectedThirdStepElement: this.$store.state.selectedThirdStepElement.id
                    }
                    this.cleanParamsValue();
                    this.$store.state.reloadFansTableSetting = true;
                }


                while (this.$store.state.fansOfPath.length > 0) {
                    this.$store.state.fansOfPath.pop();
                }

                this.$apiController.getFansOfPath(this.$store.state.selectedFirstStepElement.id, this.$store.state.selectedSecondStepElement.id).then(
                    function (response) {
                        this.$store.state.fansOfPath = this.$apiController.manageReturnedData(response, []);

                        let typesOfPath = this.$store.state.appPathsFanTypesList.filter(
                            x => x.id_app_fan_type == this.$store.state.selectedFirstStepElement.id &&
                                x.id_app_fan_sort == this.$store.state.selectedSecondStepElement.id &&
                                x.id_app_material_sort == this.$store.state.selectedThirdStepElement.id);

                        this.$store.state.fansOfPath = this.$store.state.fansOfPath.filter((x) => {
                            return typesOfPath.find((y) => {
                                return y.id_fan_type == x.id_type
                            })
                        });

                        // NVS-205 wyłączam bo nie jest już potrzebne
                        //NVS-101 Przeładowanie pozycji wybranego wentylatora, ale z zachowaniem zmienionego silnika
                        // if (this.$store.state.activeFun && this.$store.state.reloadFan) {
                            // let engine = {...this.$store.state.activeFun.engine};
                            // this.selectFanRowAsActiveInFansTable(this.$store.state.activeFun);
                            // this.$store.state.activeFun.engine = {...engine};
                            // this.$store.state.reloadFan = false;
                            // this.$store.state.changedEngine = null;
                            /*
                            let fanObj = this.$store.state.activeFun;
                            let engine_rpm = parseFloat(this.$store.state.appMeasurementsList[fanObj.selectedFanData['id_measurement']]["engine_rpm"]);
                            let frequency = parseFloat(this.$fanObjParamsManager.getNetwork_frequency(this.$store));

                            fanObj.params['installed_power'] = parseFloat(this.selectedEngine["power_" + frequency + "_hz"]);
                            fanObj.data['maximum_engine_power'] = this.$calculator.calcMaximumEnginePower(engine_rpm, fanObj.params['installed_power'], this.selectedEngine["efficiency_3_4"]);
                            fanObj.params['engine_efficiency'] = this.selectedEngine["efficiency_3_4"];
                            fanObj.engine = this.selectedEngine;

                            let countOfFans = this.$store.state.workPointParameters.elements.number_of_fans.value;
                            fanObj.params['installed_power'] = fanObj.params['installed_power'];
                            let extensionInfo = this.$calculator.getExtensionInfo(this.$store);

                            this.$fanObjParamsManager.fill_price(fanObj.selectedFanData, null, this.$store, fanObj, extensionInfo, countOfFans);
                            */
                        // }
                    }.bind(this));
            },
            cleanParamsValue() {
                this.$store.commit({
                    type: 'cleanParamsValue'
                })

                this.$store.state.fourthStepParametersSelected = JSON.parse(JSON.stringify(this.$store.state.fourthStepParameters));
                this.$store.state.selectedWorkPoint = null;

                this.cleanSelectedPartsOfGraphs();
                this.$store.state.isAdjustResultDisabled = false;

                this.$calculator.popFansTable(this.$store);

                this.$store.state.selectedFan = null;
                this.$store.state.fanToCompare = null;
                this.$store.state.fanToCompare = {
                    id: 0,
                        name: '-',
                        type: '-',
                        model: '-',
                        price: 0,
                        src: '-',
                        data: null,
                        params: [],
                        engine: null,
                        selectedFanData: null,
                };

                this.$store.state.workPointParameters.elements.number_of_fans.value = 1;

                this.$store.state.activeFun = {
                    id: 0,
                    name: '-',
                    type: '-',
                    model: '-',
                    price: 0,
                    src: '-',
                    engine: null,
                    selectedFanData: null,
                    data: null,
                    count: 1,
                    params: {
                        price: 0
                    }
                };
            },
            cleanSelectedPartsOfGraphs() {
                for (let axis in this.$store.state.partsOfTheGraph.mainAxisParams) {
                    for (let specificParts in this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts) {
                        this.$store.state.partsOfTheGraph.mainAxisParams[axis].specificParts[specificParts].active = false;
                    }
                }

                this.$store.state.partsOfTheGraphChanged++;
            },
            LoadParametersSettings() {
                for (let paramSetting in this.$store.state.fourthStepParameters) {
                    if (this.$store.state.fourthStepParameters.hasOwnProperty(paramSetting))
                        this.$store.state.fourthStepParameters[paramSetting].active = false;
                }

                for (let paramSetting of this.$store.state.appPathsParametersSettingsList) {
                    if (this.isElementSignetToCurrentPath(paramSetting)) {
                        if (this.$store.state.fourthStepParameters.hasOwnProperty(paramSetting['name']))
                            this.$store.state.fourthStepParameters[paramSetting['name']].active = true;
                    }
                }
            },
            LoadWorkPointSettings() {
                for (let workPointSetting in this.$store.state.workPointParameters.elements) {
                    if (this.$store.state.workPointParameters.elements.hasOwnProperty(workPointSetting))
                        this.$store.state.workPointParameters.elements[workPointSetting].active = false;
                }

                for (let workPointSetting of this.$store.state.appPathsWorkPointsSettingsList) {
                    if (this.isElementSignetToCurrentPath(workPointSetting)) {
                        if (this.$store.state.workPointParameters.elements.hasOwnProperty(workPointSetting['name']))
                            this.$store.state.workPointParameters.elements[workPointSetting['name']].active = true;

                        for (let element in this.$store.state.workPointParameters.elements) {
                            if (this.$store.state.workPointParameters.elements.hasOwnProperty(element) && this.$store.state.workPointParameters.elements[element].hasOwnProperty("connected") && this.$store.state.workPointParameters.elements[element].connected == workPointSetting.name)
                                this.$store.state.workPointParameters.elements[element].active = true;
                        }
                    }


                }
            },
            isElementSignetToCurrentPath(element) {
                if (parseInt(element['id_app_fan_type']) == this.$store.state.selectedFirstStepElement.id && parseInt(element['id_app_fan_sort']) == this.$store.state.selectedSecondStepElement.id)
                    return true;
                else
                    return false;
            }
        },
        mounted() {
            this.$root.$on('calculatingInProces', (args) => {
               this.calculatingInProces = args[0];
            });
        },
        beforeMount() {
            this.LoadParametersSettings();
            this.LoadWorkPointSettings();
            if (this.$store.state.productCard.loaded === false) {
                this.LoadFansOfPath();
            }
        },
    }
</script>
